import React from 'react'
import NoContent from "./NoContent";
import Helper from 'src/support/Helper';
import HCLDX from "@system/config/hcldx";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const Categories = (props) => {
    const { categoriesList, searchText } = props;
    const typeHeadSearchEvent = (obj) => {
        HelperAnalyticsEvent.typeHeadSearchEvent(searchText, "Categories", obj?.main_label, (HCLDX.baseURL() + obj?.Url))
    }
    const listMaker = (v, i) => {
        return (
            <React.Fragment key={i}>
                <li onClick={() => typeHeadSearchEvent(v)} style={{ display: 'block' }}>
                    <a href={HCLDX.baseURL() + v.Url}
                        style={{
                            cursor: 'pointer',
                            fontWeight: v.Level === 1 ? '' : ''
                        }}
                    >{v.main_label} </a>
                </li>
                {v.Categories !== undefined && v.Categories.length > 0 &&
                    v.Categories.map((v_in, i_in) => (
                        <> {listMaker(v_in, i_in)} </>
                    ))}
            </React.Fragment>
        );
    };

    return (
        <>
            <div className="search-item-title text-uppercase">RECOMMENDED Categories</div>
            <div className='search-product-list'>
                <ul className="hierarchical categories-list">
                    {categoriesList.length > 0 &&
                        <>
                            {categoriesList.map((v, i) => (
                                <React.Fragment key={Helper.UUID()}>
                                    {listMaker(v, i)}
                                </React.Fragment>
                            ))}
                        </>
                    }
                </ul>
            </div>
            {Object.keys(categoriesList).length === 0 &&
                <>
                    <NoContent />
                </>
            }
        </>
    )
}

export default Categories